// Blacklisted.js
import React from 'react';
import "./style.scss";

import ImageModal from '../ImageModal';
import { useState } from 'react';



const Archive = (props) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const [activeImage, setActiveImage] = useState('');
    const handleImageClick = (src) => {
        setActiveImage(src);
        setModalOpen(true);
      };
    
      const handleCloseModal = () => {
        setModalOpen(false);
      };
    console.log ("imageLinks from Archive", props.imageLinks);
    if (props.imageLinks) {
        return (
          <div className="archive" id="archive">
            <h1>Images Archive for Premium Users</h1>
            <p>Images of all girls you generate as a Premium user are stored as long as Stable Diffusion stores them, and are made available below.</p>
            {isModalOpen && <ImageModal src={activeImage} onClose={handleCloseModal} />}
            <ul>

              {
                props.imageLinks.map((imageLink, index) => (
                    <a target="_blank" rel="noreferrer" key={index} onClick={() => handleImageClick (imageLink)}><li>Premium Dream Girl #{index + 1}</li></a>
                ))
              }
            </ul>
          </div>
        );
      }
       else {
        return (
            <div className="archive" id="archive">
            <h1>Images Archive for Premium Users</h1>
            <p>Images of all girls you generate as a Premium user are stored as long as Stable Diffusion stores them, and will be made available below.</p>
          </div>
        );
    }

}

export default Archive;